import { render, staticRenderFns } from "./CooperationUsersDialog.vue?vue&type=template&id=de540768&scoped=true&"
import script from "./CooperationUsersDialog.vue?vue&type=script&lang=js&"
export * from "./CooperationUsersDialog.vue?vue&type=script&lang=js&"
import style0 from "./CooperationUsersDialog.vue?vue&type=style&index=0&id=de540768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de540768",
  null
  
)

export default component.exports